e4.product.variants = {
    afterFirstBuild: false,
    init: function () {
        var jProduct = jQuery( '.js-e-product' ),
            strProductId = jProduct.data( 'productId' ),
            strVariantId = jProduct.data( 'variantId' ),
            strDataPropertyPath = [
                strProductId,
                'variantCombinations',
                strVariantId
            ].join( '.' );
        e4.util.debug( e4.data.get( strDataPropertyPath ), e4.product.debug );
        if ( e4.data.get( strDataPropertyPath ) !== undefined ) {
            e4.require.js( e4.settings.require.handlebars, function () {
                e4.handlebars.registerHelpers( 'counter compare' );
                e4.handlebars.registerTemplates( '#js-e-handlebars-tmpl-product-price #js-e-handlebars-tmpl-product-number #js-e-handlebars-tmpl-product-image-carousel #js-e-handlebars-tmpl-product-image-carousel-indicators #js-e-handlebars-tmpl-product-image-modal-carousel #js-e-handlebars-tmpl-product-image-modal-carousel-indicators #js-e-handlebars-tmpl-tvilum-product-specifications' );
                e4.product.variants.bindEvents();
            } );
        }
    },
    bindEvents: function () {
        jQuery( '.js-e-product-form' ).find( '.js-e-product-form-variant-group-input' )
            .one( 'focus', function ( event ) {
                var strProductId = jQuery( event.target.form ).closest( '.js-e-product' ).data( 'productId' );
                e4.product.variants.preloadImages( strProductId );
            } )
            .on( 'change', function ( event ) {
                e4.product.variants.updateDropDownMarkup(event.target);
                e4.product.variants.changeVariant( event.target );
            } );
        jQuery( '.js-e-variant-button-reset' ).on( 'click', function ( event ) {
            event.target.form.reset();
            jQuery( event.target.form ).find( '.js-e-product-form-variant-group-input' ).first().triggerHandler( 'change' );
        } );
    },
    preloadImages: function ( strProductId ) {
        var arrVariantImages = [],
            fnLoadImages = function ( arrImageSrc, intIndex ) {
                intIndex = intIndex || 0;
                if ( arrImageSrc && arrImageSrc.length > intIndex ) {
                    var domImg = new Image();
                    domImg.onload = function () {
                        fnLoadImages( arrImageSrc, intIndex + 1 );
                    };
                    domImg.onerror = function () {
                        fnLoadImages( arrImageSrc, intIndex + 1 );
                    };
                    domImg.src = arrImageSrc[ intIndex ];
                }
            };
        jQuery.each( e4.data.get( [
            strProductId,
            'variantCombinations'
        ].join( '.' ) ), function ( strKey, objVariant ) {
            arrVariantImages.push( objVariant.imagePrimary.small );
            arrVariantImages.push( objVariant.imagePrimary.large );
            jQuery.each( objVariant.imageDetails, function ( index, objImageUrl ) {
                arrVariantImages.push( objImageUrl.small );
                arrVariantImages.push( objImageUrl.large );
            } );
        } );
        e4.util.debug( arrVariantImages, e4.product.debug );
        fnLoadImages( arrVariantImages );
    },
    changeVariant: function ( domInput ) {
        var jProductForm = jQuery( domInput.form ),
            jProduct = jProductForm.closest( '.js-e-product' ),
            strProductId = jProduct.data( 'productId' ),
            strVariantId = e4.product.variants.getVariantId( domInput.form );
        e4.product.variants.updateAvailableOptionsInAllGroups( domInput );
        e4.util.debug( [
            'changeVariant isVariantIdValid',
            e4.product.variants.isVariantIdValid( strProductId, strVariantId )
        ], e4.product.debug );
        if ( e4.product.variants.isVariantIdValid( strProductId, strVariantId ) === true ) {
            e4.product.variants.setVariantId( domInput.form, strVariantId );
            e4.product.variants.setDetails( strVariantId );
        }
        else {
            e4.product.variants.clearVariantId( domInput.form );
        }
    },
    updateDropDownMarkup: function( domInput ){
        var jElement = jQuery(domInput);
        jElement.closest('.dropdown-menu').find('.dropdown-item').removeClass('disabled');
        jElement.closest('.dropdown-menu').find('.dropdown-item').find('input[type="radio"]').prop('disabled', false);
        jElement.closest('.dropdown-item').addClass('disabled');
        jElement.prop('disabled', true);

    },
    isVariantIdValid: function ( strProductId, strVariantId ) {
        var strDataPropertyPath = [
            strProductId,
            'variantCombinations',
            strVariantId
        ].join( '.' );
        return e4.data.get( strDataPropertyPath ) !== undefined;
    },
    getVariantId: function ( domForm ) {
        var arrGroupsSelected = [];
        jQuery( domForm ).find( '.js-e-product-form-variant-group-input' ).each( function (index, element) {
            if(element.type === 'radio' ){
                if(element.checked){
                    arrGroupsSelected.push( element.value );
                }
            } else {
                arrGroupsSelected.push( jQuery( element ).val() );
            }
        } );
        return arrGroupsSelected.join( '.' );
    },
    setVariantId: function ( domForm, strVariantId ) {
        jQuery( domForm ).find( 'input[name="VariantID"]' ).val( strVariantId );
    },
    clearVariantId: function ( domForm ) {
        e4.product.variants.setVariantId( domForm, '' );
    },
    getAvailableOptionsForNextGroup: function ( objVariantMap ) {
        var objOptions = null;
        if ( objVariantMap !== null && objVariantMap.options !== undefined ) {
            objOptions = objVariantMap.options;
        }
        return objOptions;
    },
    getNextVariantMapLevel: function ( strVariantOptionId, objVariantMap ) {
        var objGroup = null;
        if ( objVariantMap !== null && objVariantMap.options !== undefined && objVariantMap.options[ strVariantOptionId ] !== undefined ) {
            objGroup = objVariantMap.options[ strVariantOptionId ];
        }
        return objGroup;
    },
    getNextGroupId: function ( objVariantMap ) {
        var strGroupId = '';
        if ( objVariantMap !== null && objVariantMap.options !== undefined ) {
            jQuery.each( objVariantMap.options, function ( strKey, objValue ) {
                strGroupId = objValue.groupId;
                // Return false to break jQuery.each loop.
                return false;
            } );
        }
        return strGroupId;
    },
    getInputNextGroup: function ( jGroupInput, jGroupInputs ) {
        var intNextGroupIndex = jGroupInputs.index( jGroupInput ) + 1;
        return jGroupInputs.eq( intNextGroupIndex );
    },
    updateAvailableOptionsInAllGroups: function ( domInput ) {
        var jProduct = jQuery( domInput ).closest( '.js-e-product' ),
            strProductId = jProduct.data( 'productId' ),
            jGroupInputs = jProduct.find( '.js-e-product-form' ).find( '.js-e-product-form-variant-group-input' ),
            objVariantMap = e4.data.get( [
                strProductId,
                'variantCombinationTree'
            ].join( '.' ) ),
            boolReleaseNextGroup = false;
        jGroupInputs.each( function ( intIndex, domGroupInput ) {
            var jGroupInput = jQuery( domGroupInput ),
                strVariantOptionId = jGroupInput.val();
            // Get first level options from variant map.
            objVariantMap = e4.product.variants.getNextVariantMapLevel( strVariantOptionId, objVariantMap );
            var jNextGroupInput = e4.product.variants.getInputNextGroup( jGroupInput, jGroupInputs ),
                jNextGroupInputOptions = jNextGroupInput.find( 'option' ).not( '[value=""]' ),
                objAvailableOptionsForNextGroup = null;
            // Get next level options from variant map.
            objAvailableOptionsForNextGroup = e4.product.variants.getAvailableOptionsForNextGroup( objVariantMap );
            // console.log( 'working on group', jGroupInput.data(), 'next group is', jNextGroupInput.data(), 'release next group', boolReleaseNextGroup );
            // Break loop if there is no next group.
            if ( jNextGroupInput.length === 0 ) {
                // console.log( 'No more groups, terminating.' );
                return false; // Return false to break jQuery.each loop.
            }
            // Release all option in group if previous group was reset.
            if ( boolReleaseNextGroup === true || jGroupInput.prop( 'selectedIndex' ) === 0 ) {
                boolReleaseNextGroup = true;
                // console.log( 'release group options', jNextGroupInput.data() );
                // jNextGroupInput.prop( 'selectedIndex', 0 );
                jNextGroupInputOptions.prop( 'disabled', false );
            }
            else {
                jNextGroupInputOptions.prop( 'disabled', function () {
                    var jOption = jQuery( this ),
                        strOptionValue = jOption.attr( 'value' ),
                        isAvailable = false;
                    // Loop all available options on next group and save disabled state.
                    for ( var strVariantOptionId in objAvailableOptionsForNextGroup ) {
                        if ( strOptionValue === strVariantOptionId ) {
                            isAvailable = true;
                            // If we find a macth, we dont need to look any further.
                            break;
                        }
                    }
                    // If current option already is selected and has been disabled, we need to reset the current
                    // select/input.
                    if ( isAvailable === false && jOption.prop( 'selected' ) === true ) {
                        // console.log( 'reset group', jNextGroupInput.data() );
                        jNextGroupInput.prop( 'selectedIndex', 0 );
                        boolReleaseNextGroup = true;
                    }
                    // Return disabled state to filter function.
                    return !isAvailable;
                } );
                // Get all options that is not disabled. If only one option is selectable we auto-select it
                var jNextGroupInputOptionsSelectable = jNextGroupInputOptions.not( ':disabled' );
                if ( jNextGroupInputOptionsSelectable.length === 1 ) {
                    // console.log( 'only 1 selectable option in ', jNextGroupInput.data(), 'autoselecting', jNextGroupInputOptionsSelectable.text() );
                    jNextGroupInputOptionsSelectable.prop( 'selected', true );
                    boolReleaseNextGroup = false;
                }
            }
        } );
    },
    setDetails: function ( strVariantId ) {
        var jProduct = jQuery( '.js-e-product' ),
            strProductId = jProduct.data( 'productId' ),
            strDataPropertyPath = [
                strProductId,
                'variantCombinations',
                strVariantId
            ].join( '.' );
        if ( e4.product.variants.isVariantIdValid( strProductId, strVariantId ) === true ) {
            var jsonProduct = e4.data.get( strDataPropertyPath );
            var strProductName = jsonProduct.name + ' - ' + jsonProduct.TvilumColourNames.split(',').join(' / ');

            console.log('strProductName', strProductName);

            jProduct.find( '.js-e-product-price' ).html( jsonProduct.price );
            jProduct.find( '.js-e-product-name' ).html( strProductName );
            jProduct.find('#tvilumSpecificationsTitle').html( strProductName );
            jProduct.find('#tvilum-product-details-search-input').val('');
            jProduct.find( '.js-e-product-number' ).html( jsonProduct.number );
            jProduct.find( '#tvilumSpecifications').data({
                productid: jsonProduct.id,
                variantid: jsonProduct.variantId
            });
            jProduct.find( '.js-e-product-images-container' ).html( e4.handlebars.tmpl.productImageCarousel( jsonProduct ) );
            jProduct.find( '.js-e-product-image-modal-container' ).html( e4.handlebars.tmpl.productImageModalCarousel( jsonProduct ) );
            jProduct.find( '.js-tvilum-product-specifications-container' ).html( e4.handlebars.tmpl.tvilumProductSpecifications( jsonProduct ) );
            jProduct.find( '.js-e-product-related-items-container' ).html( e4.handlebars.tmpl.productRelatedItems( jsonProduct ) );
            jProduct.find( '.js-e-product-primary-complementary-items-container' ).html( e4.handlebars.tmpl.productPrimaryComplementaryItems( jsonProduct ) );
            jProduct.find( '.js-e-product-secondary-complementary-items-container' ).html( e4.handlebars.tmpl.productSecondaryComplementaryItems( jsonProduct ) );

            jProduct.find( '.js-e-favorite-list' ).each( function ( intIndex, domNode ) {
                var jListInput = jQuery( domNode ),
                    strListUrlAdd = String( jListInput.data( 'url-add' ) ),
                    strListUrlRemove = String( jListInput.data( 'url-remove' ) ),
                    strListUrlAddNew = strListUrlAdd.replace( /(VariantID=).*?(&)/, '$1' + strVariantId + '$2' ),
                    strListUrlRemoveNew = strListUrlRemove.replace( /(VariantID=).*?(&)/, '$1' + strVariantId + '$2' );
                jListInput.data( 'url-add', strListUrlAddNew );
                jListInput.data( 'url-remove', strListUrlRemoveNew );
                // TODO: Check om produktet er på/i den aktuelle liste.
                jListInput.prop( 'checked', false );
            } );
        }
    }
};
